module.exports = __webpack_public_path__ + "static/img/14010201.f22bd29a.png";